import React from 'react';
import LoginAccountComponent from '../../components/LoginAccountComponent/LoginAccountComponent';

function LoginPage() {
  return <LoginAccountComponent />;
}

export default LoginPage;
